var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.logs,"items-per-page":_vm.page.pageSize,"loading":_vm.isAppLoading,"server-items-length":_vm.page.totalElements,"page":_vm.page.pageIndex,"disable-sort":true,"item-key":"id"},on:{"pagination":_vm.pageChanged},scopedSlots:_vm._u([{key:"item.courseSchedule",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.formatDate(item.courseSchedule.start)))]}},{key:"item.student",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(((item.student.firstName) + " " + (item.student.lastName))))]}},{key:"item.teacher",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(((item.teacher.firstName) + " " + (item.teacher.lastName))))]}},{key:"item.topic",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.topic.name))]}},{key:"item.comprehension",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.comprehension)+"/10")]}},{key:"item.participation",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.participation)+"/10")]}},{key:"item.motivation",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.motivation)+"/10")]}},{key:"item.comments",fn:function(ref){
var item = ref.item;
return [_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-comment-outline")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(item.comments))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }